import { AbstractConnector } from "@web3-react/abstract-connector";
import { SupportedChainId as ChainId } from "../constants/chains";
import { InjectedConnector } from "@web3-react/injected-connector";
import { NetworkConnector } from "../entities/NetworkConnector";
import RPC from "./rpc";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { PortisConnector } from "@web3-react/portis-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";

const DEFAULT_CHAIN = Number(process.env.NEXT_PUBLIC_CHAINID) || 43114;

export const network = new NetworkConnector({
  defaultChainId: DEFAULT_CHAIN,
  urls: RPC,
});

export const walletlink = new WalletLinkConnector({
  url: RPC[ChainId.AVAX],
  appName: "MetaDOS",
});

export const portis = new PortisConnector({
  dAppId: "4623a62d-3e6f-4571-b9fb-0e2c9c6cadf1" ?? "",
  networks: [1],
});

export const walletconnect = new WalletConnectConnector({
  supportedChainIds: [
    56, // binance smart chain
    97, // binance smart chain testnet
    3939,
    7979,
    43113,
    43114
  ],
  rpc: RPC,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
  pollingInterval: 15000,
  qrcodeModalOptions: {
    desktopLinks: ["metamask"],
    mobileLinks: ["metamask", "trust"],
  },
});

const supportedChainIds = Object.values(ChainId) as number[];

export const injected = new InjectedConnector({
  supportedChainIds,
});

export interface WalletInfo {
  connector?: (() => Promise<AbstractConnector>) | AbstractConnector;
  name: string;
  iconName: string;
  description: string;
  href: string | null;
  color: string;
  primary?: true;
  mobile?: true;
  mobileOnly?: true;
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  INJECTED: {
    connector: injected,
    name: "Injected",
    iconName: "injected.svg",
    description: "Injected web3 provider.",
    href: null,
    color: "#010101",
    primary: true,
  },
  METAMASK: {
    connector: injected,
    name: "MetaMask",
    iconName: "metamask.png",
    description: "Easy-to-use browser extension.",
    href: null,
    color: "#E8831D",
  },
  WALLET_CONNECT: {
    connector: walletconnect,
    name: "WalletConnect",
    iconName: "wallet-connect.svg",
    description: "Connect to Trust Wallet, Rainbow Wallet and more...",
    href: null,
    color: "#4196FC",
    mobile: true,
  },
};
